// Routes ///////////////////////////////////////////////////////////////
export const NavAnalysisRoute = (
  securityId?: string,
  navId?: string,
  tab = 'summary',
): string =>
  `/nav/analysis/?tab=${tab}${securityId ? `&security=${securityId}` : ''}${
    navId ? `&navId=${navId.toString()}` : ''
  }`;
export const NavWatchRoute = (): string => `/nav/watch`;
export const EpsWatchRoute = (): string => `/nav/eps`;

// APIs ////////////////////////////////////////////////////////////////
export const NavWatchUrl = (isNav = false): string =>
  `/api/v1/nav/watch/?is_nav=${isNav}`;
export const NavChangeFormulaUrl = (id: string): string =>
  `/api/v1/nav/security/${id}/update_scenario/`;
export const NavDataUrl = (securityId: string, navId?: string): string =>
  `/api/v1/nav/security/analysis/${securityId}/${
    navId ? `?navdamental_id=${navId}` : ''
  }`;
export const NavParametersUrl = (securityId: string, navId: string): string =>
  `/api/v1/nav/security/analysis/${securityId}/parameters/${
    navId ? `?navdamental_id=${navId}` : ''
  }`;
export const NavStockUrl = (securityId: string, navId: string): string =>
  `/api/v1/nav/security/${securityId}/portfolio/stock/${
    navId ? `?navdamental_id=${navId}` : ''
  }`;
export const NavOutOfExchangeUrl = (
  securityId: string,
  navId: string,
): string =>
  `/api/v1/nav/security/${securityId}/portfolio/out_of_exchange/${
    navId ? `?navdamental_id=${navId}` : ''
  }`;

export const NavNewFinancialYearUrl = (id: string): string =>
  `/api/v1/nav/security/analysis/${id}/financial_year/`;

export const NavPDFDownloadUrl = (
  securityId: string | number,
  type: string,
  navId: string | number,
): string =>
  `/api/v1/common/download/pdf/${securityId}/${type}/?navdamental_id=${navId}`;

export const NavOverviewUrl = (securityId: string, navId: string): string =>
  `/api/v1/nav/overview/${securityId}/${
    navId ? `?navdamental_id=${navId}/` : ''
  }`;

export const NavSummaryUrl = (securityId: string): string =>
  `/api/v1/nav/security/${securityId}/summary/`;
